import { getTheme, mergeStyleSets } from '@fluentui/react';
import * as React from 'react';

const theme = getTheme();

const styles = mergeStyleSets({
	AppFooter: [
		"AppFooter",
		{
			backgroundColor: theme.palette.neutralLight,
			padding: '5px',
			borderTop: '1px solid ' + theme.palette.neutralQuaternary,
			color: theme.palette.neutralPrimary,
			textAlign: 'center'
		}]
})

export const AppFooter: React.FC = () => {
	return <div className={styles.AppFooter}>
		&copy; 2021 <a href="https://www.reenhanced.com/" style={ {color: "inherit"}}>Reenhanced</a>
	</div>
}

export default AppFooter;